import ApprovalTransferApplicationPage from './ApprovalTransferApplicationPage'

export default ApprovalTransferApplicationPage